import React, { useState, useEffect, useContext, Component, useRef } from "react";
import "./login.css";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import axios from "../../utils/fvAxios";
import Footer from "../../reusable-components/footer/footer";
import BaseUrl from "../../utils/base-uri.json";
import { Stack, Typography, Box, IconButton, Dialog, InputAdornment } from "@mui/material";
import {
    setToken, setEmail, setUserName, setGlobalClientId, setstatuses, setOrgType, setLocalMenus, removeIncognitoEmail, setOrgId, setisEmp, getisEmp, getExpiredSec,
    getInvitationURL, getInvitationVendorId, getInvitationClientId, getInvitationIsMultiClient, getInvitationPqid, setOnSiteOffsiteDetails, setOnSiteOffsiteId, setExpiredSec,
    setMoodleUserId
} from "../../utils/Token";
import main from "../../Media/MainLogo.png";
import apiinfo from "../../utils/base-uri.json";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CryptoJS from "crypto-js";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import FormControl from '@mui/material/FormControl';
import RefreshIcon from "@mui/icons-material/Refresh";

function LoginVerification() {

    const params = new URLSearchParams(window.location.search);
    // const UserName = params.get("UserName");
    // const Password = params.get("Password");
    const NewEmail = params.get("NewEmail");
    const RememberMe = params.get("RememberMe");
    const IsSelect = params.get("isSelected");

    const [carouselFlag, setCarouselFlag] = React.useState(false);

    const [PASS, setPASS] = useState('');
    const [USER, setUSER] = useState('');
    const [Captcha, setCaptcha] = useState('');
    const [Trg, setTrg] = useState(false);

    const [spinner, setSpinner] = React.useState(false);
    const SpinnerClose = () => {
        setSpinner(false);
    };
    const navigate = useNavigate();
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const inputRefs = useRef([]);

    const [PopOpen, setPopOpen] = useState(false);
    const [AEmail, setAEmail] = React.useState('');
    const [Dis, setDis] = React.useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    // const decryptPassword = (encryptedPassword) => {
    //     const secretKey = "MyStrongSecretKey123";
    //     const decoded = decodeURIComponent(encryptedPassword);
    //     const bytes = CryptoJS.AES.decrypt(decoded, secretKey);
    //     const plain = bytes.toString(CryptoJS.enc.Utf8);
    //     return plain || "(Invalid or corrupted data)";
    // };

    const handleChange = (e, index) => {
        const value = e.target.value.replace(/\D/g, "");
        if (!value) return;
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);
        if (value && index < 5) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            const newOtp = [...otp];
            if (otp[index]) {
                newOtp[index] = "";
                setOtp(newOtp);
            } else if (index > 0) {
                inputRefs.current[index - 1].focus();
                newOtp[index - 1] = "";
                setOtp(newOtp);
            }
        }
    };

    useEffect(() => {
        // const Pass = decryptPassword(Password);
        // setPASS(Pass);

        setUSER(localStorage.getItem("ValidUser"));
        setPASS(localStorage.getItem("ValidPass"));

        const keyDownHandler = e => {
            if (e.key === 'Enter' && otp.every((val) => val !== "" && PopOpen == false)) {
                e.preventDefault();
                VerifyCode();
            }
        };
        document.addEventListener('keydown', keyDownHandler);
        return () => {
            document.removeEventListener('keydown', keyDownHandler);
        };


    }, [otp, PopOpen]);

    useEffect(() => {
        if (IsSelect == 1) {
            const Use = localStorage.getItem("ValidUser");
            const Pas = localStorage.getItem("ValidPass");
            setSpinner(true);
            const details = {
                "userName": Use,
                "password": Pas
            }
            axios.post("Login/GetCaptchaOTP", details)
                .then((res) => {
                    if (res?.data?.responseCode == 100) {
                        setCaptcha(res?.data?.data);
                        setSpinner(false);
                    } else {
                        setSpinner(false);
                        toast.error(res?.data?.responseMessage, {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    }
                })
        }

    }, [Trg]);


    const ChangeEmail = (val) => {
        const regex = /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,20})[ ]*$/i;
        if (!regex?.test(val)) {
            setAEmail(val);
            setDis(true);
        } else {
            setAEmail(val);
            setDis(false)
        }
    }

    const VerifyCode = () => {
        const OTP = otp.join('');
        const details = {
            "authCode": OTP,
            "userName": USER
        }
        axios.post("Login/ValidateAuthCode", details)
            .then((res) => {
                if (res?.data?.responseCode == 100) {
                    if (res?.data?.responseMessage == "Success") {
                        onSubmit();
                        setOtp(["", "", "", "", "", ""]);
                    }
                } else {
                    toast.error(res?.data?.responseMessage, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
            })
    }

    const SendOTPToAlternateEmail = () => {
        setDis(true);
        setSpinner(true);
        const details = {
            "email": AEmail,
            "userName": USER
        }
        axios.post("Login/SendOTPToAlternateEmail", details)
            .then((res) => {
                if (res?.data?.responseCode == 100) {
                    toast.success("Email sent Succesfully", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    setPopOpen(false);
                    setAEmail("");
                } else {
                    toast.error(res?.data?.responseMessage, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
                setDis(false);
                setSpinner(false);
            })
    }

    const ResendCode = () => {
        setSpinner(true);
        axios.post("Login/ResendAuthCode?userName=" + USER)
            .then((res) => {
                if (res?.data?.responseCode == 100) {
                    setSpinner(false);
                    toast.success("Email sent Succesfully", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
            })

    }

    const onSubmit = () => {
        const details = {
            "userName": USER,
            "password": PASS
        }
        setSpinner(true);
        axios
            .post(BaseUrl.login.loginRequest, details)
            .then((response) => {
                if (response?.data?.responseCode >= 0) {
                    setExpiredSec("0");
                    removeIncognitoEmail();
                    setToken(response?.data?.data?.token);
                    setUserName(response?.data?.data?.userName);
                    setEmail(response?.data?.data?.email);
                    setGlobalClientId(response?.data?.data?.globalClientId);
                    setOrgId(response?.data?.data?.orgId);
                    setOrgType(response?.data?.data?.orgType);
                    setLocalMenus(response?.data?.data?.userMenus);
                    setisEmp(response?.data?.data?.isEmployee);
                    setMoodleUserId(response?.data?.data?.moodleUserId);
                    //RememberMe New Function
                    if (RememberMe == "true") {
                        localStorage.setItem("username", USER);
                        localStorage.setItem("password", PASS);
                        localStorage.setItem("rememberMe", "true");
                    } else {
                        const savedUser = localStorage.getItem("username");
                        if (savedUser === USER) {
                            localStorage.removeItem("username");
                            localStorage.removeItem("password");
                            localStorage.removeItem("rememberMe");
                        }
                    }
                    //

                    axios.get(apiinfo.dashboard.GetprequalificationStatuses)
                        .then((res) => {
                            if (res?.data?.status === true) {
                                setstatuses(res?.data?.data);
                            } else {
                                alert(res.data.responseMessage);
                            }
                        })

                    axios.get(BaseUrl.login.getAnnouncement)
                        .then((response) =>
                            response.data.headers > 0
                                ? setCarouselFlag(true)
                                : setCarouselFlag(false)
                        );

                    const URL = getInvitationURL();
                    const VendorId = getInvitationVendorId();
                    const CLIENTID = getInvitationClientId();
                    const ISMultiClient = getInvitationIsMultiClient();
                    const InvitationPqid = getInvitationPqid();

                    const allowedPath = ["/registration-company"];
                    const PageName = (!URL || URL == "null" || URL == "/login?registered=success") ? (!(response?.data?.data?.isEmployee) || response?.data?.data?.isEmployee == false ? "/DashBoard" : "/EmployeeSignature") : ((URL && VendorId != 'null' && URL?.indexOf(allowedPath) !== -1) ? "/DashBoard" : (URL == "/TemplatesList" ? (URL + "?InvitationClient=" + CLIENTID + "&InvitationVendor=" + VendorId + "&InvitationIsMultiClient=" + ISMultiClient + "&pqid=" + InvitationPqid) : URL));
                    navigate(PageName);
                    localStorage.removeItem("ValidUser");
                    localStorage.removeItem("ValidPass");
                    //navigate(response?.data?.data?.userMenus[0]?.actionName)
                } else {
                    setSpinner(false);
                    toast.error(response.data.responseMessage, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });

                }

            });

    };

    return (
        <>
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Dialog fullScreen={fullScreen} open={PopOpen} onClose={() => setPopOpen(false)}>
                <DialogContent>
                    <DialogTitle
                        sx={{
                            textAlign: "center",
                            fontWeight: 500,
                            fontSize: 20,
                            flex: 1,
                        }}
                    >
                        <span style={{ fontSize: "larger" }}>Alternate Email</span>
                    </DialogTitle>

                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            setPopOpen(false)
                            setAEmail("")
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: "#D20103",
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 3 }}>
                        <Box>
                            <Typography sx={{ color: "#3E4A62", fontSize: 18 }}>
                                Email<span style={{ color: "red" }}>*</span>
                            </Typography>
                            <FormControl fullWidth>
                                <TextField
                                    sx={{
                                        mt: 1,
                                        "& legend": { display: "none" },
                                        "& fieldset": { top: 0 },
                                    }}
                                    id="outlined-basic"
                                    placeholder="Enter your email"
                                    value={AEmail}
                                    onChange={(e) => ChangeEmail(e.target.value)}
                                    variant="outlined"
                                    inputProps={{ className: "login-password" }}
                                />
                            </FormControl>
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "flex-start", gap: 2 }}>
                            <Button
                                variant="contained"
                                className="login-help-button-cancel"
                                sx={{ textTransform: "capitalize" }}
                                onClick={() => {
                                    setPopOpen(false)
                                    setAEmail("")
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                className="login-button-request"
                                sx={{ textTransform: "capitalize" }}
                                disabled={Dis || !AEmail}
                                onClick={SendOTPToAlternateEmail}
                            >
                                Send Code
                            </Button>
                        </Box>
                    </Box>
                </DialogContent>

            </Dialog>

            {/*-------Verification code---*/}
            <div id="verify" className="first-verify__loginContainer">
                <div >
                    <div className='first-verify__logo'></div>
                    <div className='first-verify__loginSubContainer'>
                        <div id="verificationcode" className="first-verify__forgetPasswordContainer">
                            <div className="first-verify__logoContaineremailverification" hidden={IsSelect == 1}></div>

                            <div className='first-verify__logindetails' style={{ paddingTop: "0px" }} hidden={IsSelect != 1}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        border: "1px solid rgba(0,0,0,0.23)",
                                        borderRadius: 1,
                                        width: "100%",
                                        backgroundColor: "#fafafa",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            flex: 1,
                                            textAlign: "center",
                                            fontSize: 30,
                                            fontWeight: 700,
                                            letterSpacing: 20,
                                            userSelect: "none",
                                        }}
                                    >
                                        {Captcha}
                                    </Box>
                                    <Box
                                        sx={{
                                            width: "1px",
                                            height: 50,
                                            backgroundColor: "rgba(0,0,0,0.23)"
                                        }}
                                    />
                                    <IconButton onClick={() => setTrg(!Trg)}>
                                        <RefreshIcon fontSize="large" />
                                    </IconButton>
                                </Box>
                            </div>

                            <span className='first-verify__loginHeading'>{IsSelect == 1 ? "Enter the captcha OTP below" : "Enter your verification code"}</span>
                            <span className='first-verify__loginSubheading' hidden={IsSelect == 1}>
                                {"We have sent a verification code to "}{NewEmail == null ? USER : NewEmail}
                            </span>
                            <div className='first-verify__logindetails' style={{ paddingTop: "0px" }}>
                                <Box display="flex" justifyContent="center" gap={1.5}>
                                    {otp.map((digit, index) => (
                                        <TextField
                                            key={index}
                                            inputRef={(el) => (inputRefs.current[index] = el)}
                                            value={digit}
                                            onChange={(e) => handleChange(e, index)}
                                            onKeyDown={(e) => handleKeyDown(e, index)}
                                            inputProps={{
                                                maxLength: 1,
                                                style: {
                                                    textAlign: "center",
                                                    fontSize: "20px",
                                                    width: "45px",
                                                    height: "45px",
                                                },
                                            }}
                                            variant="outlined"
                                        />
                                    ))}
                                </Box>
                            </div>
                            <div className='first-verify__logindetails padding-top-0 text-align-center'>
                                <Button variant="contained" className={otp.every((val) => val !== "") ? "login-button" : "login-button1"}
                                    sx={{ textTransform: "capitalize", padding: "15px" }} disabled={otp.every((val) => val !== "") ? false : true}
                                    onClick={VerifyCode} >{IsSelect == 1 ? "Verify Captcha" : "Verify Code"}</Button>
                                <Stack direction={"row"} spacing={3} hidden={IsSelect == 1}>
                                    <span className="mt-2" style={{ color: "#94979f" }}>
                                        Didn’t receive the code?
                                    </span>
                                    <div
                                        className="mt-2"
                                        variant="contained"
                                        style={{
                                            textTransform: "capitalize",
                                            color: "#2A93DB",
                                            marginLeft: "90px",
                                            cursor: "pointer",
                                        }}
                                        onClick={ResendCode}
                                    >
                                        Resend Code
                                    </div>
                                </Stack>

                                <Stack direction={"row"} spacing={1} hidden={IsSelect == 1}>
                                    <span className="mt-2" style={{ color: "#94979f" }}>
                                        Doesn't have the access to the email?
                                    </span>
                                    <div
                                        className="mt-2"
                                        variant="contained"
                                        style={{
                                            textTransform: "capitalize",
                                            color: "#2A93DB",
                                            cursor: "pointer",

                                        }}
                                        onClick={() => setPopOpen(true)}
                                    >
                                        Click here
                                    </div>
                                </Stack>
                                <Button variant="outlined" className="login-button-backtologin"
                                    onClick={() => navigate("/")}><ArrowBackIcon />{"Back"}</Button>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>

        </>
    )
}

export default LoginVerification